const Ajax = require('common/infra/ajax');

module.exports = class API {
    /**
     * 対象の DataContent のうち Import 可能な Model 一覧を取得する
     *
     * @param project
     * @param contentVersion
     * @returns {*}
     */
    listImportable(project, contentVersion) {
        const path = `/api/projects/${project.key.id}/diagrams/import/${contentVersion.key.parent.id}/versions/${contentVersion.key.id}/list`;
        return Ajax.GET(path)
            .then(data => {
                return data;
            });
    }

    import(project, contentVersion, xmiID) {
        const path = `/api/projects/${project.key.id}/diagrams/import/${contentVersion.key.parent.id}/versions/${contentVersion.key.id}/targets/${xmiID}`;
        return Ajax.GET(path)
            .then(data => {
                return data;
            });
    }

    fetchDiagramWithElements(project, diagram, importRequestID) {
        const path = `/api/projects/${project.key.id}/diagrams/${diagram.key.id}/imports/${importRequestID}/preview`;
        return Ajax.GET(path)
            .then(data => {
                return data;
            });
    }
};




// WEBPACK FOOTER //
// ./balus/infra/api/diagram/import.js